"use strict";

import { initMenu, buildAdminMenu } from '../components/menu.js';
import { initBanner } from '../components/banner.js';
import { initFooter } from '../components/footer.js';
import { initDashboadEvents } from '../components/admin-dashboad.js';
import { isLogged, getLoggedAdmin } from '../utils.js';

const baseURL = window.location.hostname === 'localhost'
  ? 'http://localhost:3000/api/admin'
  : `${process.env.API_URL}/admin`;

function initLoginEvents() {
  $('#loginForm').on('submit', function (e) {
    e.preventDefault();
    const email = $('#email').val();
    const password = $('#password').val();

    $.ajax({
      url: `${baseURL}/login`,
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({ email, password }),
      success: function (response) {
        if (response.success) {
          localStorage.setItem('admin', JSON.stringify(response.admin));
          buildAdminMenu();
          showDashboard();
        } else {
          alert('Email ou mot de passe incorrect');
        }
      },
      error: function () {
        alert('Une erreur est survenue');
      }
    });
  });
};



function showDashboard(admin) {
  $('#emamine-admin-login').empty().hide();
  $('#emamine-admin-dashboard').show().load('../../components/admin-login-dashboard.html', async function () {
    //onglet container
    await initDashboadEvents(admin);
    $('#logoutButton').on('click', function () {
      localStorage.removeItem('admin');
      showLogin();
    });
  });
}


function showLogin() {
  $('#emamine-admin-dashboard').empty().hide();
  $('#emamine-admin-login').show().load('../../components/admin-login-form.html', function () {
    initLoginEvents();
  });
}

export function initAdmin() {
  console.log("Initialisation de la page admin");
  initBanner();
  initMenu();
  const admin = getLoggedAdmin();
  if (admin) {
    showDashboard(admin);
  } else {
    showLogin();
  }

  initFooter();
}

module.exports = { initAdmin };

